module.exports = __webpack_public_path__ + "ai.7b4552df49750bda95a7.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/4x3/ai.svg
// module id = ../../../../flag-icon-css/flags/4x3/ai.svg
// module chunks = styles